import React from 'react';
import ReactDOM from 'react-dom/client';
import RandomNumber from './randomNumber';








const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<RandomNumber/>)

